// Reconstrucción vectorial provisional del símbolo V aprobado (ámbar + blanco). Pendiente de activo oficial limpio.
export const VeyraMark = ({ size = 28, className = "", title = "Veyra" }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" role="img" aria-label={title} className={className} data-testid="veyra-mark">
    <polygon points="4,10 27,10 60,90 37,90" fill="#F5B544" />
    <polygon points="37,90 60,90 79,50 62,55" fill="#F5B544" />
    <polygon points="45,10 96,10 71,50" fill="#F4F1EC" />
  </svg>
);

export const VeyraWordmark = ({ height = 22, className = "" }) => (
  <span className={`font-display font-bold lowercase leading-none text-[#F4F1EC] ${className}`} style={{ fontSize: height * 1.15, letterSpacing: "-0.03em" }} data-testid="veyra-wordmark">
    veyra
  </span>
);

const VeyraLogo = ({ size = 28, showWordmark = true, className = "" }) => (
  <div className={`inline-flex items-center gap-2.5 ${className}`} data-testid="veyra-logo">
    <VeyraMark size={size} />
    {showWordmark && <VeyraWordmark height={size * 0.78} />}
  </div>
);

export default VeyraLogo;
